import { render, staticRenderFns } from "./login_index.vue?vue&type=template&id=6a1cfdc8&scoped=true&"
import script from "./login_index.vue?vue&type=script&lang=js&"
export * from "./login_index.vue?vue&type=script&lang=js&"
import style0 from "./login_index.vue?vue&type=style&index=0&id=6a1cfdc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1cfdc8",
  null
  
)

export default component.exports